import { useCommunityInboxStore } from "@circle-react/hooks/chatsV2/store";
import { useCommunityBotProfileSearch } from "./useCommunityBotProfileSearch";

export const useShouldShowAgentsTab = () => {
  const { botProfiles } = useCommunityBotProfileSearch({ name: "" });

  const { memberChats } = useCommunityInboxStore();
  return botProfiles?.length > 0 || memberChats?.length > 0;
};
